import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'CommentableCommentDatum',
    column_type: 'id',
  },
  created_at: {
    model_name: 'CommentableCommentDatum',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'CommentableCommentDatum',
    column_type: 'datetime',
  },
  comments_count: {
    model_name: 'CommentableCommentDatum',
    column_type: 'integer',
  },
  approved_comments_count: {
    model_name: 'CommentableCommentDatum',
    column_type: 'integer',
  },
  deleted_comments_count: {
    model_name: 'CommentableCommentDatum',
    column_type: 'integer',
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
